import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user'
import app from './module/app'
import tab from './module/tab'
import home from './module/nportal'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        user,
        app,
        tab,
        home
    },
    getters: {
        theme: state => state.app.theme,
        color: state => state.app.color,
        multiTab: state => state.app.multiTab,

        token: state => state.user.token,
        rsaPublicKey: state => state.user.rsaPublicKey,
        avatar: state => state.user.avatar,
        userName: state => state.user.name,
        userId: state => state.user.id,
        menus: state => state.user.menus,
        apps: state => state.user.apps,
        departs: state => state.user.departs,
        currentMenuCode: state => state.user.currentMenuCode,
        userInfo: state => state.user.info,


        stationPath: state => state.home.stationPath,
        metaTitle: state => state.home.metaTitle,
        currentPage: state => state.home.currentPage,
        stationTheme: state => state.home.stationTheme,
        stationBackpic: state => state.home.stationBackpic,
        siteType: state => state.home.siteType,
        logoSize: state => state.home.logoSize,
        siteUuid: state => state.home.siteUuid,

        tabs: state => state.tab.tabs,
        activeTab: state => state.tab.activeTab,
        pathBox: state => state.tab.pathBox,
        closeObj: state => state.tab.closeObj,
        homeFetch: state => state.tab.homeFetch,
    }
})